/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * ThemeVariablesRootStyles
 *
 * @file ThemeVariablesRootStyles.js
 * @author Anuja Gaikwad
 * @description Root class that defines CSS variables for light mode only.
 *              Dark mode variables are intentionally NOT set here so existing
 *              dark styles continue to work via var(..., fallback) usage.
 */

import { makeStyles } from '@material-ui/core';
import mixins from '../../../assets/styles/mixins.scss';

const useThemeVariablesRootStyles = makeStyles({
  themedRoot: {
    // Define CSS variables only when light theme is explicitly applied.
    // For dark theme, we rely on existing styles and var() fallbacks.
    '&.theme-light': {
      '--bg_quaternary': mixins.bg_quaternary,
      '--color_footer_bg': mixins.colorFooterBg,
      '--lightBgColor': mixins.lightBgColor,
      '--color_text_primary': mixins.color_text_primary,
      '--lightInactiveBgColor': mixins.lightInactiveBgColor,
      '--transparentBgColor': 'transparent',
      '--fontFamily': mixins.fontFamilyPlusSansPrimary,
      '--fontWeight400': '400px',
      '--fontWeight500': '500px',
      '--skeletonColor': mixins.skeletonColor,
      '--fontSize32': mixins.fontSize32,
      '--lineHeight40': '40px',
      '--letterSpacing64': '-0.64px',
      '--fontSize14': '14px',
      '--fontSize24': '24px',
      '--lineHeight16': '16px',
      '--lineHeight22': '22px',
      '--lineHeight28': '28px',
      '--lineHeight30': '30px',
      '--letterSpacing0': '0px',
      '--letterSpacing4': '-0.4px',
      '--letterSpacing48': '-0.48px',
      '--grayScaleTextSecondary': mixins.grayScaleTextSecondary,
      '--purpleSecondaryText': mixins.purpleSecondaryText,
      '--lightBgColor1': mixins.lightBgColor1,
      '--secondaryButtonFocusColor': mixins.secondaryButtonFocusColor
    }
  }
});

export default useThemeVariablesRootStyles;
